module.exports = __webpack_public_path__ + "static/media/error.e6dce550.mp3";